import React from 'react';
interface CodeEditorProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  language?: 'html' | 'css' | 'javascript';
  description?: string;
}
export function CodeEditor({
  label,
  language = 'html',
  description,
  className = '',
  ...props
}: CodeEditorProps) {
  return <div className="space-y-2" data-id="element-626">
      <div className="flex justify-between items-baseline" data-id="element-627">
        <label className="block text-sm font-medium text-gray-900" data-id="element-628">
          {label}
        </label>
        <span className="text-xs text-gray-500 font-mono uppercase" data-id="element-629">
          {language}
        </span>
      </div>
      {description && <p className="text-sm text-gray-500" data-id="element-630">{description}</p>}
      <div className="relative rounded-md shadow-sm" data-id="element-631">
        <textarea className={`block w-full rounded-md border-gray-300 font-mono text-sm focus:border-blue-500 focus:ring-blue-500 bg-slate-50 min-h-[200px] p-4 ${className}`} spellCheck={false} {...props} data-id="element-632" />
      </div>
    </div>;
}